import React, { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../../app/hooks';
import { tryToAddIntegration, tryToEditIntegration } from '../../../../store/brokers/partner/integrations/IntegrationsSlice';
import SelectCheckbox from '../../../../shared/select-checkbox';
import Button from '../../../../shared/button';
import Error from '../../../../shared/error';
import Modal from '../../../../shared/modal';
import Input from '../../../../shared/input';

const integrationList = [
    { label: 'Xero', value: 'xero' }
]

interface IManageIntegrationModal {
    openModal: boolean;
    id?: string;
    data?: any;
    onSaveSuccessfully: (type: string, message: string) => void;
    handleCloseModal: () => void;
}

const ManageIntegrationModal = ({
    openModal,
    id,
    data,
    onSaveSuccessfully,
    handleCloseModal
}: IManageIntegrationModal) => {
    const dispatch = useAppDispatch();
    const [createError, setCreateError] = useState<string | null>();
    const [integrationsData, setIntegrationsData] = useState<any>();
    const [name, setName] = useState<any>();

    const onCloseModal = () => {
        handleCloseModal();
        setName(undefined)
        setIntegrationsData(undefined)
        setCreateError(undefined)
    }

    useEffect(() => {
        if (id && data) {
            setName(data?.name)
            const formatIntgData = data?.data && Object?.keys(data?.data)?.map((item: any) => {
                return {
                    'keyValue': data?.data?.item,
                    'keyName': item
                }
            })
            setIntegrationsData(formatIntgData)
        }
    }, [id, data, openModal])

    const onSelectName = (e: any, type?: string) => {
        setName(e)
    }

    const onChangeDataKeys = (e: any, type?: string, index?: number) => {
        if (type && (index || index === 0)) {
            const formatData = integrationsData && integrationsData?.length > 0 ? integrationsData?.map((item: any, id: number) => {
                if (id === index) {
                    return {
                        ...item || {},
                        [type]: e
                    }
                } else {
                    return item
                }
            })
                : [{
                    [type]: e
                }]
            setIntegrationsData(formatData)
        }
    }

    const onDeleteDataKeys = (index: number) => {
        const filterOtherData = integrationsData && integrationsData?.length > 0 && integrationsData?.filter((item: any, id: number) => id !== index)
        setIntegrationsData(filterOtherData)
    }

    const onAddNewRow = () => {
        setIntegrationsData([...integrationsData || [], {}])
    }

    const onSubmit = async () => {
        try {
            let formatIntgData: any = {}
            integrationsData && integrationsData?.length > 0 && integrationsData?.map((item: any) => {
                formatIntgData = {
                    ...formatIntgData || {},
                    [item?.keyName]: item?.keyValue
                }
                return item
            })
            const payloadData = {
                name: name,
                data: formatIntgData
            }
            if (id) {
                await dispatch(tryToEditIntegration({ id, data: payloadData })).unwrap();
            } else {
                await dispatch(tryToAddIntegration(payloadData)).unwrap()
            }
            onSaveSuccessfully('success', 'Integration saved successfully')
            setCreateError(undefined)
            onCloseModal()
        } catch (err) {
            setCreateError(`${err}`)
        }
    }

    return (
        <Modal
            open={openModal}
            showInRight
            contentContainerStyle='!min-w-[100vw] md:!min-w-[650px]'
            onClose={onCloseModal}>
            <div className={'p-2 min-w-[95vw] md:min-w-[600px]'}>
                <p className='mb-4 font-semibold text-sm'>Manage Integration</p>
                {createError && <Error text={createError} />}
                <div className='bg-[#e4ede657] rounded-[6px] p-3 my-9'>
                    <SelectCheckbox
                        name='Integration Name'
                        placeholder=' '
                        options={integrationList}
                        selectedOption={name}
                        disabled={!!id}
                        onChangeSelectedOption={onSelectName}
                    />
                    {[...Array(integrationsData?.length || 1)]?.map((item: any, index: number) => {
                        const findData = integrationsData?.[index]
                        return (
                            <div key={index} className='mb-5'>
                                <div className='grid grid-cols-2 gap-3'>
                                    <Input
                                        label='Key Name'
                                        inputUniqueName='keyName'
                                        index={index}
                                        showValue={true}
                                        inputValue={findData?.keyName}
                                        onChangeInput={onChangeDataKeys}
                                    />
                                    <Input
                                        label='Key Value'
                                        inputUniqueName='keyValue'
                                        index={index}
                                        showValue={true}
                                        inputValue={findData?.keyValue}
                                        onChangeInput={onChangeDataKeys}
                                    />
                                </div>
                                {id &&
                                    <div className='flex flex-row justify-end mb-4'>
                                        <Button
                                            label={'Delete'}
                                            className='btn-primary-text-underline'
                                            onClickButton={() => onDeleteDataKeys(index)}
                                        />
                                    </div>
                                }
                            </div>
                        )
                    })}
                    <div className='flex flex-row justify-center my-3'>
                        {(integrationsData && integrationsData?.length > 0) &&
                            <Button
                                label={'Add New Pair'}
                                className='btn-primary-text-underline'
                                onClickButton={onAddNewRow}
                            />
                        }
                    </div>
                </div>
                <div className='flex flex-row justify-center py-2'>
                    <Button
                        label={id ? 'Save Changes' : 'Create Integration'}
                        dataQa={'create'}
                        className={'btn-primary-rounded-less'}
                        onClickButton={onSubmit}
                    />
                </div>
            </div>
        </Modal>
    )
}
export default ManageIntegrationModal;